import React from 'react';
import { Card, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import Breadcrumb from 'Components/Common/Breadcrumb';
import Detail from './Detail';

const MrWaterIndex = () => {
  document.title = "Усны салбарын байгууллага";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb title="Үндсэн бүртгэл" breadcrumbItem="Усны салбарын байгууллага" />
          <Row>
            {/* <Filter /> */}
            <Detail />
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

export default MrWaterIndex;